import CapitolIcon from './CapitolIcon'

export default CapitolIcon
